import { render, staticRenderFns } from "./IG160.vue?vue&type=template&id=0cb30882&scoped=true&"
import script from "./IG160.vue?vue&type=script&lang=js&"
export * from "./IG160.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb30882",
  null
  
)

export default component.exports